import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine1Headline1,
  TextBoxMaxLine2Body1,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockDescriptionForSpecialRowProps extends Omit<
  ITextBlockProps,
  'children'
> {
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
}

export const TextBlockDescriptionForSpecialRow = ({
  title = '',
  description = '',
  rowGap = TextBlockRowGap.INDENT_0,
  ...rest
}: ITextBlockDescriptionForSpecialRowProps): JSX.Element => (
  <TextBlock rowGap={rowGap} {...rest} width={100}>
    <TextBoxMaxLine1Headline1 title={title} />
    <TextBoxMaxLine2Body1 title={description} />
  </TextBlock>
)
